<template>
  <main class="main page-inside">
    <div class="main-wrapper">
      <section class="section hero-section product-list-section">
        <div class="wrapper">
          <div class="top">
            <div class="search-contaier">
              <button :class="['filter-btn', {'active': filtersIsVisible}]" @click="openFilter">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.2188 4.53125H11.7188C11.2873 4.53125 10.9375 4.18148 10.9375 3.75C10.9375 3.31852 11.2873 2.96875 11.7188 2.96875H19.2188C19.6502 2.96875 20 3.31852 20 3.75C20 4.18148 19.6502 4.53125 19.2188 4.53125Z"
                    fill="black"
                  />
                  <path
                    d="M0.78125 4.53125H3.25938C3.58188 5.44055 4.45027 6.09375 5.46875 6.09375H7.03125C8.32359 6.09375 9.375 5.04234 9.375 3.75C9.375 2.45766 8.32359 1.40625 7.03125 1.40625H5.46875C4.45027 1.40625 3.58191 2.05945 3.25938 2.96875H0.78125C0.349766 2.96875 0 3.31852 0 3.75C0 4.18148 0.349766 4.53125 0.78125 4.53125ZM5.46875 2.96875H7.03125C7.46203 2.96875 7.8125 3.31922 7.8125 3.75C7.8125 4.18078 7.46203 4.53125 7.03125 4.53125H5.46875C5.03797 4.53125 4.6875 4.18078 4.6875 3.75C4.6875 3.31922 5.03797 2.96875 5.46875 2.96875Z"
                    fill="black"
                  />
                  <path
                    d="M0.78125 10.7812H11.0719C11.3944 11.6905 12.2628 12.3438 13.2812 12.3438H14.8438C15.8622 12.3438 16.7306 11.6905 17.0531 10.7812H19.2188C19.6502 10.7812 20 10.4315 20 10C20 9.56852 19.6502 9.21875 19.2188 9.21875H17.0531C16.7306 8.30945 15.8622 7.65625 14.8438 7.65625H13.2812C12.2628 7.65625 11.3944 8.30945 11.0719 9.21875H0.78125C0.349766 9.21875 0 9.56852 0 10C0 10.4315 0.349766 10.7812 0.78125 10.7812ZM13.2812 9.21875H14.8438C15.2745 9.21875 15.625 9.56922 15.625 10C15.625 10.4308 15.2745 10.7812 14.8438 10.7812H13.2812C12.8505 10.7812 12.5 10.4308 12.5 10C12.5 9.56922 12.8505 9.21875 13.2812 9.21875Z"
                    fill="black"
                  />
                  <path
                    d="M19.2188 15.4688H9.24063C8.91813 14.5595 8.04973 13.9062 7.03125 13.9062H5.46875C4.45027 13.9062 3.58191 14.5595 3.25938 15.4688H0.78125C0.349766 15.4688 0 15.8185 0 16.25C0 16.6815 0.349766 17.0312 0.78125 17.0312H3.25938C3.58188 17.9405 4.45027 18.5938 5.46875 18.5938H7.03125C8.04973 18.5938 8.91809 17.9405 9.24063 17.0312H19.2188C19.6502 17.0312 20 16.6815 20 16.25C20 15.8185 19.6502 15.4688 19.2188 15.4688ZM7.03125 17.0312H5.46875C5.03797 17.0312 4.6875 16.6808 4.6875 16.25C4.6875 15.8192 5.03797 15.4688 5.46875 15.4688H7.03125C7.46203 15.4688 7.8125 15.8192 7.8125 16.25C7.8125 16.6808 7.46203 17.0312 7.03125 17.0312Z"
                    fill="black"
                  />
                </svg>
                <div class="title title-18">
                  <b>Filters</b>
                </div>
              </button>
              <div class="search">
                <input type="text" v-model="search" @keyup.enter="onEnter" />
                <div class="clear">
                  <img
                    class="img"
                    src="./../img/cross.svg"
                    @click="clearSearch()"
                  />
                </div>
                <img
                  class="glass"
                  src="./../img/glass.svg"
                  @click="searchSubmit()"
                />
              </div>
              <div class="select-container" v-if="sortOptions.length">
                <div class="desc gray desc-14">Sort by:</div>
                <Select2
                  class="select2 single"
                  v-model="sort"
                  :options="sortOptions"
                  placeholder="Highest price first"
                  @select="selectSort($event)"
                />
              </div>
            </div>
            <div :class="['filters', {'active': filtersIsVisible}]">
              <div class="filters-wrapper">
                <div class="left">
                  <div
                    class="select-container"
                    v-if="newCategoryOptions.length"
                  >
                    <Select2
                      class="select2 single"
                      v-model="category"
                      :options="newCategoryOptions"
                      placeholder="Choose type"
                      @select="selectCategory($event)"
                    />
                  </div>
                  <div class="select-container" v-if="qualityOptions.length">
                    <Select2
                      class="select2 single"
                      v-model="quality"
                      :options="qualityOptions"
                      placeholder="Quality"
                      @select="selectQuality($event)"
                    />
                  </div>
                  <div class="select-container select-container-range">
                    <div class="desc">
                      <b>Price:</b>
                    </div>
                    <div class="val-container">
                      <div class="val min">
                        <input type="number" v-model="barMinValue" />
                        <PriceFormatter tag="div" rootClass="curr" />
                        <div class="desc">min</div>
                      </div>
                      <div class="divider">-</div>
                      <div class="val max">
                        <input type="number" v-model="barMaxValue" />
                        <PriceFormatter tag="div" rootClass="curr" />
                        <div class="desc">max</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="select-container select-container-reset">
                  <div class="reset orange-btn" @click="resetFilters">
                    Reset
                  </div>
                </div>
              </div>
            </div>
          </div>
          <transition name="fade">
            <div class="list products" v-if="productList">
              <div class="item" v-for="(item, i) in productList" :key="i">
                <ProductCard
                  :item="item"
                  :addToCartChosenItem="addToCartChosenItem"
                  :sliderIsClickble="true"
                  @goToProduct="goToProduct"
                  :currency="currency"
                  @addToCart="addToCart"
                />
              </div>
            </div>
          </transition>
          <div
            class="no-items-found"
            v-if="Array.isArray(productList) && !productList.length"
          >
            No items found
          </div>
          <pagination
            v-if="totalProducts"
            v-model="activePage"
            :records="totalProducts"
            :per-page="18"
            @paginate="changePage"
          />
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import Select2 from "vue3-select2-component";
import Pagination from "vue-pagination-2";
import ProductCard from "../components/ProductCard.vue";
import { mapGetters } from "vuex";
import PriceFormatter from "../components/PriceFormatter.vue";

export default {
  name: "ProductListPage",
  props: ["addToCartChosenItem", "productCategory", "searchedProductText"],
  components: {
    Select2,
    Pagination,
    ProductCard,
    PriceFormatter,
  },
  data: function () {
    return {
      imgDomain: "",
      filtersIsVisible: false,
      sort: "desc",
      category: "",
      quality: "",
      activePage: 1,
      totalProducts: null,
      sortOptions: [
        {
          id: "desc",
          text: "Highest price first",
        },
        {
          id: "asc",
          text: "Lowest price first",
        },
      ],
      qualityOptions: {},
      barMinValue: 0,
      barMaxValue: 1200,
      productList: {},
      search: ''
    };
  },
  watch: {
    currency: function () {
      this.filterProducts();
    },
    barMinValue: function () {
      this.activePage = 1;
      this.filterProducts();
    },
    barMaxValue: function () {
      this.activePage = 1;
      this.filterProducts();
    },
    productCategory: function () {
      this.activePage = 1;
      this.filterProducts();
    },
    searchedProductText: function () {
      this.activePage = 1;
      this.filterProducts();
    },
  },
  computed: {
    newCategoryOptions() {
      let newCategories = [...this.$parent.categoryOptions];
      newCategories.unshift("All types");
      return newCategories;
    },
    ...mapGetters("app", ["currency"]),
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    if (this.productCategory === "all") {
      this.$parent.setProductCategory("");
    }
    const effectiveCategory =
      this.productCategory && this.productCategory !== "all"
        ? this.productCategory
        : "";
    const typePart = effectiveCategory ? "&type=" + effectiveCategory : "";
    const searchPart = this.searchedProductText
      ? "&search=" + encodeURIComponent(this.searchedProductText)
      : "";
    this.$http
      .get(
        process.env.VUE_APP_API +
          "items/list?page=1&sort=desc&limit=18" +
          typePart +
          searchPart +
          "&currency=" +
          this.currency
      )
      .then((res) => {
        this.productList = res.data.payload;
        this.totalProducts = res.data.meta.total;
      })
      .catch((res) => {
        if (res.response.status === 401) {
          this.$parent.openSignIn();
        }
      });

    this.$parent.getCategoryOptions();
    this.getQualityOptions();
  },
  methods: {
    searchSubmit() {
      this.$emit("searchSubmit", this.search);
    },
    onEnter() {
      this.searchSubmit();
    },
    clearSearch() {
      this.$parent.clearSearch();
    },
    selectSort(event) {
      this.activePage = 1;
      this.sort = event.id;
      this.filterProducts();
    },
    selectCategory(event) {
      this.activePage = 1;
      this.category = event.text;
      this.$parent.setProductCategory(event.text);
    },
    selectQuality(event) {
      this.activePage = 1;
      this.quality = event.text;
      this.filterProducts();
    },
    resetFilters() {
      this.quality = "All quality";
      this.category = "All types";
      this.qualityOptions = "";
      this.$parent.getCategoryOptions();
      this.getQualityOptions();
      this.barMinValue = 0;
      this.barMaxValue = 1200;
      this.filterProducts();
      this.$parent.clearSearch();
    },
    openFilter() {
      this.filtersIsVisible = !this.filtersIsVisible;
    },
    filterProducts() {
      let addCategory = "";
      const effectiveCategory =
        this.productCategory && this.productCategory !== "all"
          ? this.productCategory
          : "";
      if (this.category != "All types" && effectiveCategory) {
        addCategory = "type=" + effectiveCategory;
      }

      let addQuality = "";
      if (this.quality != "All quality") {
        addQuality = "&quality=" + this.quality;
      } else {
        addQuality = "";
      }
      let addPrice =
        "&price_from=" + this.barMinValue + "&price_till=" + this.barMaxValue;

      let addSort = "&sort=" + this.sort;

      let addPage = "&page=" + this.activePage;

      let addCurrency = "&currency=" + this.currency;

      let addSearch = this.searchedProductText
        ? "&search=" + encodeURIComponent(this.searchedProductText)
        : "";

      this.$http
        .get(
          process.env.VUE_APP_API +
            "items/list?" +
            addCategory +
            addQuality +
            addPrice +
            addSort +
            addPage +
            addCurrency +
            addSearch +
            "&limit=18"
        )
        .then((res) => {
          this.productList = res.data.payload;
          this.totalProducts = res.data.meta.total;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
        });
    },
    changePage(page) {
      this.activePage = page;
      this.filterProducts();
    },

    getQualityOptions() {
      this.$http
        .get(process.env.VUE_APP_API + "items/filter-data")
        .then((res) => {
          let newQuality = res.data.payload.qualities;
          newQuality.unshift("All quality");
          this.qualityOptions = newQuality;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
        });
    },
    addToCart(item, id) {
      this.$emit("addToCart", item, id);
    },
    goToProduct(item) {
      this.$emit("goToProduct", item);
    },
  },
};
</script>

<style scoped>
.no-items-found {
  width: 100%;
  text-align: center;
  padding: 60px 20px;
  font-size: 20px;
  font-weight: 600;
  color: #6b7280;
}
</style>
